import { render, staticRenderFns } from "./MoreFeatures.vue?vue&type=template&id=d2a96f4e&scoped=true"
import script from "./MoreFeatures.vue?vue&type=script&lang=js"
export * from "./MoreFeatures.vue?vue&type=script&lang=js"
import style0 from "./MoreFeatures.vue?vue&type=style&index=0&id=d2a96f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a96f4e",
  null
  
)

export default component.exports